/**
 * Desktop mouse-drag for Dawn slideshow-component (Flickity-like swipe).
 *
 * Dawn's slider already supports touch swipe via overflow-x + scroll-snap.
 * Mouse drag does nothing on desktop; this script clicks Dawn's own prev/next
 * controls after a horizontal drag so we never reimplement slide maths.
 *
 * Live translate is skipped on purpose: the track is `.slider--everywhere`
 * (overflow-x: auto, scroll-snap-type: x mandatory, scrollTo from global.js).
 * A transform wrapper would fight those transitions. A clean snap is better.
 *
 * Fail-safe: supporting CSS is scoped under html.slideshow-drag-init, which
 * this script adds only after it finds a slideshow AND its control buttons.
 * No JS / JS error / reduced motion / coarse pointer = Dawn as-shipped.
 */
(function () {
  'use strict';

  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;

  var SNAP_PX = 60;
  var CLICK_SUPPRESS_PX = 5;

  function isControl(target) {
    return !!target.closest(
      'button.slider-button, .slider-counter__link, .slideshow__autoplay, .slideshow__controls'
    );
  }

  function suppressClick(event) {
    event.preventDefault();
    event.stopPropagation();
  }

  function bind(component) {
    if (component.dataset.slideshowDragBound) return false;

    var track = component.querySelector('.slideshow') || component.querySelector('[id^="Slider-"]');
    var prev = component.querySelector('button.slider-button--prev');
    var next = component.querySelector('button.slider-button--next');
    if (!track || !prev || !next) return false;

    component.dataset.slideshowDragBound = 'true';

    var dragging = false;
    var startX = 0;
    var dx = 0;

    function endDrag() {
      if (!dragging) return;
      dragging = false;
      track.classList.remove('is-dragging');
      track.style.cursor = '';

      var distance = Math.abs(dx);
      if (distance >= SNAP_PX) {
        if (dx < 0) {
          next.click();
        } else {
          prev.click();
        }
      }
      if (distance > CLICK_SUPPRESS_PX) {
        track.addEventListener('click', suppressClick, true);
        setTimeout(function () {
          track.removeEventListener('click', suppressClick, true);
        }, 0);
      }
      dx = 0;
    }

    track.addEventListener('pointerdown', function (event) {
      if (dragging) return;
      if (event.button !== 0) return;
      if (event.pointerType === 'touch') return;
      if (isControl(event.target)) return;
      dragging = true;
      startX = event.clientX;
      dx = 0;
      track.classList.add('is-dragging');
      track.style.cursor = 'grabbing';
      if (track.setPointerCapture) {
        try {
          track.setPointerCapture(event.pointerId);
        } catch (err) {}
      }
    });

    track.addEventListener('pointermove', function (event) {
      if (!dragging) return;
      dx = event.clientX - startX;
    });

    track.addEventListener('pointerup', endDrag);
    track.addEventListener('pointercancel', endDrag);

    track.addEventListener('dragstart', function (event) {
      event.preventDefault();
    });

    return true;
  }

  var bound = 0;
  document.querySelectorAll('slideshow-component').forEach(function (component) {
    if (bind(component)) bound += 1;
  });

  if (!bound) return;

  document.documentElement.classList.add('slideshow-drag-init');
})();
